import { Box, Grid } from '@material-ui/core';
import { formatMoney, Income } from '@nemuru-eng/js-api-client';

import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

import { useCustomTheme } from '../../../../hooks/useCustomTheme';
import { Font } from '../../../shared/components/Font';
import { IconHeader } from '../../../shared/components/IconHeader';
import { Text } from '../../../shared/components/Text';

export function NetIncome({ income }: { income: Income }) {
  const { palette } = useCustomTheme();

  return (
    <Grid
      className="appear-anim"
      container
      style={{
        borderBottom: `1px solid ${palette.grey[200]}`,
        paddingBlock: '16px',
        alignItems: 'center',
      }}
    >
      <Grid item xs={12} lg={3}>
        <IconHeader
          labelTid={'DETECTED_INCOMES'}
          subLabelTid={'LAST_12_MONTHS'}
          iconName={'euro'}
          color={'secondary'}
        />
      </Grid>
      <Grid item xs={12} lg={2}>
        <Box paddingY={2}>
          <Font variant="subtitle2" color="textSecondary">
            <Text tId={'MONTHLY'} />
          </Font>
          <br />
          <Font variant="h5" color="textPrimary">
            {formatMoney(amountToValueMoneyMapper(income.netIncome.monthlyNetIncome))}
          </Font>
        </Box>
      </Grid>

      <Grid item xs={12} lg={2}>
        <Box paddingY={2}>
          <Font variant="subtitle2" color="textSecondary">
            <Text tId={'ANNUAL'} />
          </Font>
          <br />
          <Font variant="h5" color="textPrimary">
            {formatMoney(amountToValueMoneyMapper(income.netIncome.annualNetIncome))}
          </Font>
        </Box>
      </Grid>
      <Grid item xs={12} lg={2}>
        <Box paddingY={2}>
          <Font variant="subtitle2" color="textSecondary">
            <Text tId={'INCOME_TYPE'} />
          </Font>
          <br />
          <Font variant="h5" color="textPrimary">
            <Text tId={income.netIncome.netIncomeType} />
          </Font>
        </Box>
      </Grid>
      <Grid item xs={12} lg={3}>
        <Box paddingY={2}>
          <Font variant="subtitle2" color="textSecondary">
            <Text tId={'ORIGIN'} />
          </Font>
          <br />
          <Font variant="h5" color="textPrimary">
            <Text tId={income.type} />
          </Font>
        </Box>
      </Grid>
    </Grid>
  );
}
